export const UPDATE_PARTITIONS = 'UPDATE_PARTITIONS';

export const savePartitionOrder = (data) => ({ type: UPDATE_PARTITIONS, data });
